/**
 * Remote development - connect to deployed backend.
 * Uses HTTPS for secure communication. Override via fileReplacements at build time if needed.
 */
export const environment = {
  production: false,
  apiUrl: 'https://api.dev.anubisgate.eu',
  /** Dev portal hosts agent install artifacts under /client/anubis-agent/ */
  installScriptBaseUrl: 'https://my.dev.anubisgate.eu',
};

